import Modal from 'utils/packages/Modal';
import Share from 'utils/packages/rnShare';
const canUseWebShare = () => typeof window !== 'undefined' && !!window.navigator?.share;
const copyToClipboard = async (text) => {
    try {
        await window.navigator.clipboard.writeText(text);
        return true;
    }
    catch {
        return false;
    }
};
const copyOrShow = async (message, copiedTitle) => {
    if (await copyToClipboard(message)) {
        Modal.showError('Paste it into a message to send it to your friends.', undefined, copiedTitle, 'Okay');
    }
    else {
        Modal.showError(message, undefined, 'Invite to the group', 'Okay');
    }
};
/**
 * Shares the message with the Web Share API. Browsers without it (e.g. Firefox
 * on desktop), or that refuse to share for a reason other than the user closing
 * the sheet, get the message copied to the clipboard instead. If the browser
 * refuses that too, the message is shown to copy by hand.
 */
export const shareGroupMessage = async (message, copiedTitle) => {
    if (!canUseWebShare()) {
        await copyOrShow(message, copiedTitle);
        return undefined;
    }
    try {
        await Share.open({ message });
        return { message, success: true };
    }
    catch (error) {
        if (!(error instanceof Error && error.name === 'AbortError')) {
            await copyOrShow(message, copiedTitle);
        }
        return undefined;
    }
};
export const shareGroupLink = ({ name, joiningLink }) => shareGroupMessage(`Use this link to join the group ${name} in Emma:
${joiningLink}`, 'Group link copied');
export const shareGroupCode = ({ name, accessCode }) => shareGroupMessage(`Use this code to join the group ${name} in Emma:
${accessCode}`, 'Group code copied');
